import axios from 'axios';

const DEFAULT_API_BASE_URL = 'http://127.0.0.1:8000';
const configuredApiBaseUrl = (import.meta.env.VITE_API_BASE_URL || DEFAULT_API_BASE_URL).trim();

const API_KEY = import.meta.env.VITE_API_KEY;

axios.interceptors.request.use((config) => {
	if (API_KEY) {
		config.headers['Authorization'] = `Api-Key ${API_KEY}`;
	}
	return config;
});

export const API_BASE_URL = configuredApiBaseUrl.replace(/\/+$/, '');

export const API_URL = API_BASE_URL.endsWith('/api') ? API_BASE_URL : `${API_BASE_URL}/api`;

export const fetchEvents = () => axios.get(`${API_URL}/events/`);
export const fetchEventDetails = (slug) => axios.get(`${API_URL}/events/${encodeURIComponent(slug)}/`).then((response) => {
	const event = response.data || {};
	const sessions = Array.isArray(event.sessions) ? event.sessions : [];
	const normalizedSessions = sessions.map((session) => ({
		...session,
		venue: session.venue || null,
		location_label: session.location_label || session.location || session.venue?.address || '',
	}));

	return {
		...response,
		data: {
			...event,
			should_show_remaining_tickets: Boolean(event.should_show_remaining_tickets),
			sessions: normalizedSessions,
		},
	};
});
export const registerForEvent = (eventId, payload) => axios.post(`${API_URL}/events/${eventId}/register/`, payload);
export const registerForFreeEvent = (eventSlug, payload) => axios.post(
	`${API_URL}/events/${encodeURIComponent(eventSlug)}/register/free/`,
	payload,
);
export const sendEventRegistrationOtp = (eventSlug, payload) => axios.post(
	`${API_URL}/events/${encodeURIComponent(eventSlug)}/register/send-otp/`,
	payload,
);
export const verifyEventRegistrationOtp = (eventSlug, payload) => axios.post(
	`${API_URL}/events/${encodeURIComponent(eventSlug)}/register/verify-otp/`,
	payload,
);
export const validateEventCoupon = (eventSlug, payload) => axios.post(
	`${API_URL}/events/${encodeURIComponent(eventSlug)}/coupons/validate/`,
	payload,
);
export const saveEventConsent = (eventSlug, payload) => axios.post(
	`${API_URL}/events/${encodeURIComponent(eventSlug)}/consent/`,
	payload,
);
export const fetchAttendanceEventInfo = (token) => axios.post(`${API_URL}/attendance/event-info/`, {
	token,
	challenge_token: token,
});
export const sendAttendanceOtp = (eventSlug, payload) => axios.post(
	`${API_URL}/events/${encodeURIComponent(eventSlug)}/attendance/send-otp/`,
	payload,
);

export const confirmAttendanceAction = (eventSlug, payload) => axios.post(
	`${API_URL}/events/${encodeURIComponent(eventSlug)}/attendance/confirm/`,
	payload,
);
export const confirmHostedPayment = (payload) => axios.post(`${API_URL}/payments/hosted/confirm/`, payload);
export const fetchPaymentStatus = (transactionRef) => axios.get(`${API_URL}/payments/status/${encodeURIComponent(transactionRef)}/`);
export const fetchManualPayment = (purchaseRef) => axios.get(`${API_URL}/payments/manual/details/${encodeURIComponent(purchaseRef)}/`);
export const initiateManualPayment = (purchaseRef, payload) => axios.post(`${API_URL}/payments/manual/initiate/${encodeURIComponent(purchaseRef)}/`, payload);
export const updateAttendeeInfo = (payload, method = 'POST') => {
	const normalizedMethod = String(method || 'POST').toUpperCase();
	if (normalizedMethod === 'PATCH') {
		return axios.patch(`${API_URL}/attendees/update/`, payload);
	}
	return axios.post(`${API_URL}/attendees/update/`, payload);
};
export const getPaymentReceiptUrl = (transactionRef) => `${API_URL}/payments/receipt/${encodeURIComponent(transactionRef)}/`;
export const getPaymentTicketUrl = (transactionRef) => `${API_URL}/payments/ticket/${encodeURIComponent(transactionRef)}/`;
export const downloadPaymentReceipt = (transactionRef) => axios.get(getPaymentReceiptUrl(transactionRef), { responseType: 'blob' });
export const downloadPaymentTicket = (transactionRef) => axios.get(getPaymentTicketUrl(transactionRef), { responseType: 'blob' });
